import { throttle } from '@pogokid/util/lodash'
import { DependencyList, useCallback, useMemo } from 'react'

/**
 * Create a throttled function with dependencies
 *
 * ```
 * const fn = useThrottleFn((e) => {
 *   setY(e.clientY)
 * }, 100, [setY])
 * ```
 *
 * @param fn   The function to throttle
 * @param ms   The wait period in ms
 * @param deps useCallback dependencies
 */
export function useThrottleFn<
  Args extends any[],
  F extends (...args: Args) => void
>(fn: F, ms: number, deps: DependencyList = []) {
  const cb = useCallback<F>(fn, deps)
  return useMemo(() => throttle(ms, cb), [cb, ms])
}
